import { useQuery } from 'react-query';
import { BranchesService } from '../../services';
import { IBranchTransferPreview } from '../../interfaces';

export const useBranchTransferPreview = (fromBranchId?: number, toBranchId?: number) =>
  useQuery<IBranchTransferPreview, Error>(
    ['branch-transfer-preview', fromBranchId, toBranchId],
    async () => {
      const result = await BranchesService.getTransferPreview(fromBranchId!, toBranchId!);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    // No focus refetch: the counts would shift under the user's status/container selection mid-form.
    { enabled: !!fromBranchId && !!toBranchId, cacheTime: 0, retry: false, refetchOnWindowFocus: false },
  );
